module.exports = __webpack_public_path__ + "static/roanokehh-74607ae4865403c188221248a415c9ff.jpg";